export default "__VITE_ASSET__CwrrJJG0__"